export const MeteringPointDirectionEnum = Object.freeze({
  CONSUMPTION: "CONSUMPTION",
  GENERATION: "GENERATION"
});
